import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class NodeDetails extends BaseComponent {
	
	static get properties() {
		return {	
			nodeId: {type: String}
		};
	}
	
	constructor() {
		super();
		
		var nodeDetails = this;
		setTimeout(function(){
			nodeDetails.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var nodeDetails = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['ADMIN_SYSTEM:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete Node')
					],
					listeners: {
						click: function() {
							actionDeleteNode();
						}
					}
				}				
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'key',
					header: 'Key',					
					width: '5em',
					renderer: function(root, column, rowData) {
						if (rowData.item.section) {
							root.style = 'background-color: grey; color: white; font-size: 20px; text-shadow: 2px 2px 2px #000;';
						} else if (rowData.item.subSection) {
							root.style = 'background-color: rgb(138 167 193);';
						} else {
							root.style = '';
						}
						root.innerHTML = rowData.item.key;
					}
				},
				{						
					path: 'value',
					header: 'Value',						
					'flex-grow': '1',
					renderer: function(root, column, rowData) {
						if (rowData.item.section) {
							root.style = 'background-color: grey; color: white; font-size: 20px;';
						} else if (rowData.item.subSection) {
							root.style = 'background-color: rgb(138 167 193);';
						} else {
							root.style = '';
						}
						root.innerHTML = rowData.item.value;
					}
				}				
			]
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		nodeDetails.append(flexLayout);		
		
		
		var actionRefresh = function() {
			var loadMask = nodeDetails.showLoading();			
			Service.getNodeService().getNodeStatus(nodeDetails.nodeId).then(function(status){
				Service.getNodeService().getEmailStats(nodeDetails.nodeId).then(function(emailStats){
					Service.getNodeService().getRoutingStats(nodeDetails.nodeId).then(function(routingStats){
						loadMask.remove();

						var fullList = [];
						fullList.push({
							key: '<b>General</b>',
							section: true,
							value: '&nbsp;'
						});

						for (var key in status) {
							if (key !== 'systemProperties' &&
								key !== 'heapMemoryStatus' &&
								key !== 'nonHeapMemoryStatus' &&
								key !== 'memoryPools' )	{

								var value = status[key];

								if (key === 'freeDiskSpace' ||
									key === 'usedDiskSpace'	||
									key === 'totalDiskSpace') {
									value += ' mb';								
								}
								if (key === 'startTime') {
									value = TimeUtil.formatDateStandard(TimeUtil.parseDate(value));
								}

								fullList.push({
									key: key,								
									value: value
								});						
							}
						}

						//heap memory
						fullList.push({
							key: '<b>HEAP MEMORY</b>',
							section: true,
							value: '&nbsp;'
						});
						for (var key in status.heapMemoryStatus) {
							fullList.push({
								key: key,								
								value: status.heapMemoryStatus[key]
							});	
						}


						//memory pools
						fullList.push({
							key: '<b>MEMORY POOLS</b>',
							section: true,
							value: '&nbsp;'
						});
						status.memoryPools.forEach(function(pool){
							for (var key in pool) {
								var subSection = false;
								if (key === 'name') {
									subSection = true;
								}

								fullList.push({
									key: key,
									subSection: subSection,
									value: pool[key]
								});	
							}
						});					
						
						fullList.push({
							key: '<b>ROUTING STATS</b>',
							section: true,
							value: '&nbsp;'
						});											
						for (var key in routingStats.stats) {
							var value = routingStats.stats[key];
							
							fullList.push({
								key: key,								
								value: value
							});	
						}						
						
						fullList.push({
							key: '<b>EMAIL STATS</b>',
							section: true,
							value: '&nbsp;'
						});
						for (var key in emailStats) {
							var value = emailStats[key];
							if (key === 'lastSuccessDts') {
								if (value) {
									value = TimeUtil.formatDateStandard(TimeUtil.parseDate(value));
								}
							}

							fullList.push({
								key: key,								
								value: value
							});	
						}						

						//props
						fullList.push({
							key: '<b>SYSTEM PROPERTIES</b>',
							section: true,
							value: '&nbsp;'
						});	
						for (var key in status.systemProperties) {
							fullList.push({
								key: key,
								value: status.systemProperties[key]
							});	
						}

						grid.items = fullList;					

					});
				});
			});	
		};
		actionRefresh();
		
		var actionDeleteNode = function() {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete Node',
				message: 'Are you sure you want to delete node record? <br> <br> (This will only delete the current record. Live nodes will recreate the record.)',				
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = nodeDetails.showLoading('Deleting...');
							Service.getNodeService().deleteNode(nodeDetails.nodeId).then(function(detailInfo){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted Node', {									
									theme: 'success'
								});
								
								
								var deleteEvent = new CustomEvent('deleteNode', { detail: '' });
								nodeDetails.dispatchEvent(deleteEvent);
							});							
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};
		
	}
	
};
customElements.define('dl-node-details', NodeDetails);

